import { render, staticRenderFns } from "./BuilderSidebarElements.vue?vue&type=template&id=994392e0&scoped=true&"
import script from "./BuilderSidebarElements.vue?vue&type=script&lang=js&"
export * from "./BuilderSidebarElements.vue?vue&type=script&lang=js&"
import style0 from "./BuilderSidebarElements.vue?vue&type=style&index=0&id=994392e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994392e0",
  null
  
)

export default component.exports